module.exports = __webpack_public_path__ + "static/media/chokha-dine2.3ba61cf6.jpg";